module.exports = __webpack_public_path__ + "img/9788961701198.c7dcfa51.jpg";